import { Action, Dispatch } from 'redux';

import { TICKETS_URL } from 'appConstants';
import { PortalPreferenceAction, AppState } from 'reducers';
import { ApiRequest } from 'services';
import { Ticket, ToastMessage } from 'types';

enum Actions {
  START_POLLING = 'START_POLLING',
  STOP_POLLING = 'STOP_POLLING',
  SET_CURRENT_TICKET = 'SET_CURRENT_TICKET',
  SET_TOAST_MESSAGE = 'SET_TOAST_MESSAGE',
  RESET_TOAST_MESSAGE = 'RESET_TOAST_MESSAGE',
}

export interface PollingTicketAction extends Action {
  readonly currentPollingTicket?: Ticket;
  readonly toastList?: ToastMessage[];
}

export interface PollingTicketStatus {
  readonly isPolling: boolean;
  readonly toastList: ToastMessage[];
  readonly currentPollingTicket: Ticket;
}

const initialState = {
  isPolling: false,
  toastList: [],
  currentPollingTicket: {} as Ticket,
} as PollingTicketStatus;

/* To start polling */
const startPolling = (): PollingTicketAction => ({
  type: Actions.START_POLLING,
});

const setToastMessage = (toastList: ToastMessage[]): PollingTicketAction => ({
  type: Actions.SET_TOAST_MESSAGE,
  toastList,
});

const resetToastMessage = (): PollingTicketAction => ({
  type: Actions.RESET_TOAST_MESSAGE,
});

/* To close resume ticket modal */
const stopPolling = (): PollingTicketAction => ({
  type: Actions.STOP_POLLING,
});

const setCurrentPollingTicket = (
  currentPollingTicket: Ticket,
): PollingTicketAction => ({
  type: Actions.SET_CURRENT_TICKET,
  currentPollingTicket,
});

const pollingTicketsReducer = (
  state = initialState,
  action: PollingTicketAction,
) => {
  switch (action.type) {
    case Actions.START_POLLING:
      return {
        ...state,
        isPolling: true,
      };
    case Actions.SET_TOAST_MESSAGE:
      return {
        ...state,
        toastList: action.toastList,
      };
    case Actions.RESET_TOAST_MESSAGE:
      return {
        ...state,
        toastList: [],
      };
    case Actions.STOP_POLLING:
      return {
        ...state,
        isPolling: false,
      };
    case Actions.SET_CURRENT_TICKET:
      return {
        ...state,
        currentPollingTicket: action.currentPollingTicket,
      };
    default:
      return state;
  }
};

/* Thunk */

const getTicketDetails = (ticketId: string) => async (
  dispatch: Dispatch<PortalPreferenceAction>,
  getState: () => AppState,
) => {
  const onSuccess = (ticket: Ticket) => {
    dispatch(setCurrentPollingTicket(ticket));
  };

  const onError = () => {
    dispatch(setCurrentPollingTicket(initialState.currentPollingTicket));
  };

  return ApiRequest.get(`${TICKETS_URL}/${ticketId}`, {
    headers: {
      'x-show-meta': 'true',
      'x-async': 'true',
    },
    onSuccess,
    onError,
  });
};

export {
  startPolling,
  stopPolling,
  setToastMessage,
  resetToastMessage,
  pollingTicketsReducer,
  getTicketDetails,
};
